<template>
  <div class="print-wrapper">
    <div class="print-header">
      <span class="print-header-title" v-if="pageTitle"><strong v-html="pageTitle"></strong></span>
      <span class="print-header-title" v-else>印刷ページ名: {{ state.title }}</span>
      <span class="print-header-logo"><strong>LC</strong>LEGAL CONNECTION</span>
    </div>
    <div class="print-container" id="print-container">
      <!-- プリントするコンテンツ -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, watch } from '@vue/composition-api'
import store from '@/store'

export default defineComponent({
  props: {
    pageTitle: {
      type: String,
      default: ''
    }
  },
  setup (props, context) {

    const state = reactive({
      title: ''
    })

    watch(() => store.state.print.title, (newVal, oldVal) => {
      if (newVal) {
        state.title = newVal
      }
    })
   
    return {
      state
    }
  }
})
</script>

<style lang="scss" scoped>

.print-wrapper {
  display: none;
  @media print {
    background-color: #fff;
    display: block!important;
    position: absolute;
    z-index: 999;
    top: 0;
    left: 0;
    right: 0;
  }
}
.print-header {
  position: relative;
  &-title {
    display: block;
    color: $color-content;
    font-size: 1.2rem;
    width: calc(100% - 144px);
    strong {
      font-size: 1.4rem;
      font-weight: bold;
    }
  }
  &-logo {
    position: absolute;
    top: 0;
    right: 0;
    color: $color-link;
    font-size: 1.0rem;
    strong {
      font-size: 1.4rem;
      margin-right: 10px;
    }
  }
}
.print-container {
  @media print {
    margin-top: 32px;
  }
}
</style>
